import api from './index';

interface LessonProps {
  player_lesson_id?: number;
  lesson_position?: number;
  unit_position?: number;
  level_position?: number;
}

interface LessonFeedbackProps extends LessonProps {
  survey_result: boolean;
  activity_start_time?: Date;
  activity_end_time?: Date;
}

const postLessonFeedback = (props: LessonFeedbackProps) => {
  return api.post(`/v4/lesson/feedback`, props);
};

interface ActivityCompletedProps extends LessonProps {
  start_at: Date;
  end_at: Date;
  activity_number: number;
  activity_id: string;
}

const postActivityCompleted = (props: ActivityCompletedProps) => {
  return api.post(`/v4/feedback/lesson/${props.lesson_position}/activity_completed`, props);
};

const postLessonCompleted = (props: LessonProps) => {
  return api.post(`/v4/feedback/lesson/${props.lesson_position}/lesson_completed`, props);
};

const postContinuePressed = (props: LessonProps) => {
  return api.post(`/v4/feedback/lesson/${props.lesson_position}/continue_pressed`, props);
};

const postPlayerClosed = (props: LessonProps) => {
  return api.post(`/v4/feedback/lesson/${props.lesson_position}/player_closed`, props);
};

export {
  postLessonFeedback,
  postActivityCompleted,
  postLessonCompleted,
  postContinuePressed,
  postPlayerClosed,
};
